module.exports = __webpack_public_path__ + "img/start-membership.03355177.svg";